import { DollarSign, FileText, Home, Settings } from "lucide-react";
import { FC } from "react";
import { ActiveTabClient, useClientStore } from "../clients.store";

type Props = {};

export const LeftSidebar: FC<Props> = () => {
  return (
    <div className="col-span-3">
      <div className="bg-white rounded-lg shadow p-2 space-y-1 sticky top-4">
        <TabButton
          id={ActiveTabClient.INFO}
          icon={Home}
          label="Client Information"
        />
        <TabButton id={ActiveTabClient.RATES} icon={DollarSign} label="Rates" />
        <TabButton
          id={ActiveTabClient.DOCUMENTS}
          icon={FileText}
          label="Documents"
        />
        <TabButton
          id={ActiveTabClient.PREFERENCES}
          icon={Settings}
          label="Preferences"
        />
      </div>
    </div>
  );
};

type TabProps = {
  id: ActiveTabClient;
  icon: React.ComponentType<{ size: number }>;
  label: string;
};

const TabButton: FC<TabProps> = ({ id, icon: Icon, label }) => {
  const { formState, setActiveTab } = useClientStore();
  return (
    <button
      type="button"
      onClick={() => setActiveTab(id)}
      className={`flex items-center space-x-2 px-4 py-3 rounded-lg transition-colors w-full
        ${
          formState.activeTab === id
            ? "bg-blue-100 text-blue-700 font-medium"
            : "hover:bg-gray-100"
        }`}
    >
      <Icon size={20} />
      <span>{label}</span>
    </button>
  );
};
